import * as binderAlertRates from "../../enums/binderAlertRates";
import * as targetLayout from "../searchResults/targetLayout";
import * as binderIds from "../../enums/binderIds";
import customizeTabForUser from "./customizeTabForUser";

export function unsavedBinderFromApiBinder(apiBinder) {
	return {
		...apiBinder,
		id: binderIds.UNASSIGNED,
		tabs: apiBinder.tabs.map((tab, index) => ({
			...tab,
			client_id: index,
			id: index,
			binder_id: binderIds.UNASSIGNED,
		})),
		observers: [],
		alert_history: false,
		alert_rate: binderAlertRates.NONE,
	};
}

export function applyUserLayouts(binder, content) {
	const transformed = { ...binder };
	if (binder.tabs && targetLayout.hasGlobalDefaults(content, binder.type, binder.tabs)) {
		transformed.tabs = binder.tabs.map(t => customizeTabForUser(content, t, binder.type));
	}
	return transformed;
}
